import { render, staticRenderFns } from "./MarketThnx.vue?vue&type=template&id=690e195a&"
import script from "./MarketThnx.vue?vue&type=script&lang=js&"
export * from "./MarketThnx.vue?vue&type=script&lang=js&"
import style0 from "./MarketThnx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports